import {useMemo, useState} from 'react'
import {PageHeader} from '../components/ui/page-header'
import {WarningPill} from '../components/ui/warning-pill'
import {FoniBgControls, FoniCanvas, FoniParamsTable, FoniRowEditor} from '../components/foni'
import {computeBackground, formatWarning, type BgColor, type FoniRow} from '../lib/lvs-foni'

const DEFAULT_ROWS: readonly FoniRow[] = [
    {text: 'Rīga 5 km', h: 350, variant: 'A'},
    {text: 'Baltezers', h: 250, variant: 'A'}
]

export function FoniPage() {
    const [rows, setRows] = useState<readonly FoniRow[]>(DEFAULT_ROWS)
    const [bgColor, setBgColor] = useState<BgColor>('white')
    const [strike, setStrike] = useState(false)

    const layout = useMemo(() => computeBackground({rows, bgColor}), [rows, bgColor])

    return (
        <div className='space-y-8'>
            <PageHeader
                eyebrow='LVS 77-3:2016 / 9.13.–9.20. un tabulas 9.14–9.16'
                title='Foni'
            />

            <div className='space-y-5'>
                <FoniBgControls
                    bgColor={bgColor}
                    onBgColorChange={setBgColor}
                    strike={strike}
                    onStrikeChange={setStrike}
                />
                <FoniRowEditor
                    rows={rows}
                    onChange={setRows}
                />
            </div>

            {layout.warnings.length > 0 && (
                <div className='flex flex-wrap gap-2'>
                    {layout.warnings.map((w, i) => (
                        <WarningPill key={i}>{formatWarning(w)}</WarningPill>
                    ))}
                </div>
            )}

            <FoniCanvas
                layout={layout}
                bgColor={bgColor}
                strike={strike}
            />

            <FoniParamsTable
                layout={layout}
                bgColor={bgColor}
                strike={strike}
            />
        </div>
    )
}
